import {
  RnOrganizationsProfileVM,
} from "src/app/shared/services/rnapi2-service/models/models";

export class QBOSubscriptionData {
  public organization: RnOrganizationsProfileVM;
  public startingStep: number = 0;
  public selectedItem?: any;
  public ID?: string;
  public productChangeType: string;
  public isAddOnAttach?: boolean;
  public clear(): void{
    this.organization = null;
    this. startingStep = null;
    this.selectedItem = null;
    this.ID = null;
    this.productChangeType = null;
    this.isAddOnAttach = null;
  }
}
